@if (fields?.length) {
  <section>
    <h2>{{ heading || t.getCustomFieldsText() }}</h2>
    <dl>
      @for (field of fields; track $index) {
        <dt>{{ field.name }}</dt>
        <dd>
          @if (field.type === 'boolean') {
            {{ field.value ? t.getYesText() : t.getNoText() }}
          } @else {
            {{ field.value }}
          }
          @if (field.type === 'number' && field.unit) {
            {{ field.unit }}
          }
        </dd>
      }
    </dl>
  </section>
}
